
import { RecipeCard } from "@/components/profile/RecipeCard";

interface Recipe {
  id: string;
  title: string;
  description: string | null;
  image_url: string | null;
  visibility: "public" | "subscription";
  user: {
    username: string;
  };
}

interface RecipesViewProps {
  recipes: Recipe[];
}

export const RecipesView = ({ recipes }: RecipesViewProps) => {
  // Filter out recipes without images
  const recipesWithImages = recipes?.filter(recipe => recipe.image_url !== null) || [];

  console.log("Recipes after filtering:", recipesWithImages);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {recipesWithImages.map((recipe) => (
        <RecipeCard
          key={recipe.id}
          title={recipe.title}
          imageUrl={recipe.image_url}
          visibility={recipe.visibility}
          isSubscribed={true}
          profileUsername={recipe.user?.username || 'Unknown User'}
          recipeId={recipe.id}
        />
      ))}
    </div>
  );
};
